module.exports = __webpack_public_path__ + "img/04062023.f79cb915.png";